/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <a-button :type="userBtnType||props.btnType||'primary'"
            :danger="props.danger===true?true:false"
            :class="[props.bgColor?'userDefBtn':'',props.borderRadius,(isDes&&(props.disabled||disabled))?'disbaleDes':'']"
            :shape="props.round?'round':''"
            :ghost="props.ghost"
            :disabled="isDes?false:props.disabled||disabled"
            :size="size||props.size"
            @click="clickEventFun"
            class="xmButton btnBase"
            :loading="loadingFlag||showLoadingFlag"
            v-show="vuex['showCtl']!==false"
            :style="[elBaseStyle,props.bgColor?'--btn-bg-color:'+props.bgColor:'',props.labelColor?'--btn-font-color:'+props.labelColor:'']"
  >
    <template #icon><span :class="props.btnIcon" v-if="props.btnIcon"
                          :style="'color:'+props.iconColor"
                          style="padding-right: 4px"></span></template>
    <span v-if="props.hideLabel!==true">
        {{ btnLabel || props.label }}
      </span>
    <slot></slot>
  </a-button>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "btnBase",
});
</script>

<script lang="ts" setup>
import {Button as AButton} from "ant-design-vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useCtlShowState} from "@/main-page/ctls/hooks/useCtlShowState";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";

interface propTypes {
  userBtnType:string;
  size:string;
  disabled:boolean,
  btnLabel: string,
  loadingFlag:boolean,
  props: any,
  events: any,
  aclKey: string,
  styles: any,
  model: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  styles: {},
  size:'',
  aclKey: '',
  disabled:false,
  loadingFlag:false,
  userBtnType:'',
  btnLabel: '',
  events: [],
  props: {},
  model: {},
})
const { props, styles, model, events,  aclKey,btnLabel}: any = toRefs(propsPage);

const {  showLoadingFlag} = useCtlShowState({sectionConfig: props});
const {elBaseStyle,isDes} = useCtlStyle({styles,props});
const {vuex} = useVuexState({sectionConfig:props,vuexProps:['showCtl']});

const emits = defineEmits(['clickBtn']);
const FORCE_CLOSE_MS = 5000;
let forceCloseTimer: any = null;

const clearForceCloseTimer = () => {
  if (forceCloseTimer) {
    clearTimeout(forceCloseTimer);
    forceCloseTimer = null;
  }
};

const closeShowLoading = () => {
  clearForceCloseTimer();
  showLoadingFlag.value = false;
};

const clickEventFun = () => {
  if(propsPage.disabled){
    return ''
  }
  //点击后立刻在按钮上显示 loading，动作结束后由父组件 loadingFlag 关闭
  if(unref(props).clickLoading===true){
    showLoadingFlag.value=true;
    clearForceCloseTimer();
    forceCloseTimer = setTimeout(() => {
      showLoadingFlag.value = false;
      forceCloseTimer = null;
    }, FORCE_CLOSE_MS);
  }
  emits('clickBtn', {btnId: unref(props).value || unref(props).key});
}

watch(() => propsPage.loadingFlag, (val, oldVal) => {
  if (unref(props).clickLoading !== true) {
    return;
  }
  if (val) {
    clearForceCloseTimer();
    showLoadingFlag.value = true;
  } else if (oldVal && !val) {
    closeShowLoading();
  }
});

onBeforeUnmount(() => {
  clearForceCloseTimer();
});
</script>

<style type="text/css" lang="less">
.ant-modal {
  .ant-modal-footer {
    .panelBtns {
      .xmButton {
        .ant-btn {
          line-height: 1;
        }
      }
    }
  }
}
.ant-btn.userDefBtn.xmButton.btnBase{
  color: var(--btn-font-color,#333);
  border-color: var(--btn-bg-color,#f0f0f0);
  background: var(--btn-bg-color,#f0f0f0);
}
.ant-btn-round.xmButton{
  border-radius: 50%;
}
.ant-btn.disbaleDes{
  color: rgba(0, 0, 0, 0.25) !important;
  border-color: #d9d9d9 !important;
  background: #f5f5f5 !important;
  &.ant-btn-link{
    border-color: transparent !important;
    background: transparent !important;
  }
}
.ant-btn-round.xmButton{
  &.bdSmall{
    border-radius: 4px;
  }
  &.bdDefault{
    border-radius: 8px;
  }
  &.bdBig{
    border-radius: 50%;
  }
  &.userDefDb{
    border-radius: var(--borderUserInput,4px);

  }
}
.xmButton{
  .ant-btn-round{
    height: 100%;
  }
}
</style>
